import { createAction, props } from '@ngrx/store';

export const setPipelineReleaseViewRouteParameters = createAction(
  `[Routing] Set Pipeline Release View route parameters`,
  props<{
    deliveryGuid: string;
    pipelineId: string;
    microdeliveryId?: string;
    pipelineRunId?: number;
    pipelineRunKey?: string;
    expectedCentralPolicyKeys?: string[];
  }>(),
);
